/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Seo_ImageInputs */

const vi_shop_seo_image = /** @type {(inputs: Shop_Seo_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh chia sẻ (SEO)`)
};

/**

* @param {Shop_Seo_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_seo_image = /** @type {((inputs?: Shop_Seo_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Seo_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_seo_image(inputs)
});